export default __webpack_public_path__ + "static/media/arrow_right_grey.c0bebd0a.svg";